import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Column, Columns, Container } from '@resurs/midas-react'
import { getText } from '../../../internal/TextLabels'
import Table from './Table'
import Page from '../../../internal/Page'
import Pagination from './Pagination'
import { getSettingsHistory } from '../../../store/actions/settings-actions'
import LoaderOverlay from './LoaderOverlay'
import { useOnMount } from '../../../util/utility-hooks'

const createHeaders = () => [
  {
    key: 'history-date',
    text: getText('settingsHistory.headers.date'),
    style: {
      width: '150px',
      textAlign: 'left',
    },
    dataFunc: d => (d.created && moment(d.created / 1000).format('L LT')) || '',
  },
  {
    key: 'history-user',
    text: getText('settingsHistory.headers.user'),
    field: 'user.userName',
    style: { width: '200px', textAlign: 'left' },
  },
  {
    key: 'history-action',
    text: getText('settingsHistory.headers.action'),
    style: { textAlign: 'left' },
    dataFunc: event =>
      getText(`settingsHistory.${event.system}.${event.type}`, {
        _action: getText(`settingsHistory.actions.${event.action}`),
        ...event.parameters,
      }),
  },
]

const History = ({ getHistory, data, page, loading }) => {
  useOnMount(() => {
    getHistory()
  })

  return (
    <Container grid960>
      <Columns>
        <Column col1 colMd0 />
        <Column col10 colMd12>
          <Container>
            <h4>{getText('settingsHistory.header')}</h4>
            <div>{getText('settingsHistory.description')}</div>
          </Container>
        </Column>
      </Columns>
      <Columns>
        <Column col1 colMd0 />
        <Column col10 colMd12>
          <LoaderOverlay loading={loading}>
            <Page>
              <Table
                headers={createHeaders()}
                data={data}
                dataKey="id"
                dataCy="history-list"
                loading={loading}
              />
              <Pagination
                onNext={() =>
                  getHistory({
                    page: page.number + 1,
                    size: page.size,
                  })
                }
                onPrev={() =>
                  getHistory({
                    page: page.number - 1,
                    size: page.size,
                  })
                }
                onRowsPerPageChange={size => getHistory({ size })}
                page={page}
              />
            </Page>
          </LoaderOverlay>
        </Column>
      </Columns>
    </Container>
  )
}

History.propTypes = {
  data: PropTypes.array.isRequired,
  page: PropTypes.object.isRequired,
  getHistory: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
}

const mapStateToProps = state => ({
  loading: state.settings.historyLoading,
  data: state.settings.history.content || [],
  page: state.settings.history.page || {},
})

const mapDispatchToProps = dispatch => ({
  getHistory: pagination => dispatch(getSettingsHistory(pagination)),
})

export default connect(mapStateToProps, mapDispatchToProps)(History)
